import { Location } from "./location";

/** Asset rows returned on employee API when `include_assets` is used (portal). */
export interface EmployeeAssignedAsset {
  id: number;
  uuid: string;
  assetTag?: string | null;
  asset_tag?: string | null;
  serialNumber?: string | null;
  serial_number?: string | null;
  model?: string | null;
  manufacturer?: string | null;
  deviceType?: string | null;
  device_type?: string | null;
  status?: string | null;
}

export function formatAssignedAssetLabel(a: EmployeeAssignedAsset): string {
  const tag = a.assetTag ?? a.asset_tag;
  const sn = a.serialNumber ?? a.serial_number;
  return [tag, sn].filter(Boolean).join(" · ") || a.model || "Asset";
}

/** Device type, manufacturer, model, serial — for employee asset lists. */
export function formatAssignedAssetDeviceLine(a: EmployeeAssignedAsset): string {
  const deviceType = (a.deviceType ?? a.device_type ?? "").trim();
  const manufacturer = (a.manufacturer ?? "").trim();
  const model = (a.model ?? "").trim();
  const serial = (a.serialNumber ?? a.serial_number ?? "").trim();
  const parts = [deviceType, manufacturer, model, serial].filter(Boolean);
  return parts.length ? parts.join(" · ") : formatAssignedAssetLabel(a);
}

export function getAssignedAssetFields(a: EmployeeAssignedAsset) {
  return {
    deviceType: (a.deviceType ?? a.device_type ?? "").trim() || "—",
    manufacturer: (a.manufacturer ?? "").trim() || "—",
    model: (a.model ?? "").trim() || "—",
    serial: (a.serialNumber ?? a.serial_number ?? "").trim() || "—",
  };
}

export interface Employee {
  id: number;
  uuid: string;
  /** Identifier from your HR / IT system (not Assettech’s internal id). */
  externalEmployeeId?: string | null;
  firstName?: string;
  lastName?: string;
  email?: string;
  jobTitle?: string;
  department?: string;
  status: string;
  remoteWorker?: boolean;
  assets?: EmployeeAssignedAsset[];
  /** Managed site from the Locations directory. */
  officeLocation?: Location | null;
  officeLocationId?: number | null;
  homeAddress?: string | null;
  homeAddress2?: string | null;
  homeCity?: string | null;
  homeState?: string | null;
  homeZipcode?: string | null;
  homeCountry?: string | null;
  createdAt?: string;
  updatedAt?: string;
}
